import * as React from 'react';
import { useMutation } from '@apollo/client';
import * as DeleteWaiver from 'core/gql/mutations/delete-waiver';
import * as GetForm from 'core/gql/queries/show-form';
import { Button, Icon } from '@teamsnap/teamsnap-ui';
import { NgbWaiverPill } from './NgbWaiverPill';
import { WaiverPillButton, FlexPillButton, NewWaiver } from '.';
import * as Types from './types';

interface Props {
  formId: number;
  waivers: Types.Waiver[];
  ngbIntegration: any;
  setWaivers: (waiver: Types.Waiver[]) => void;
  handleWaiverSave: (waiver: Types.Waiver) => void;
  handleWaiverUpdate: (waiver: Types.Waiver) => void;
}

const WaiverForm: React.FC<Props> = ({ formId, waivers, setWaivers, handleWaiverSave, handleWaiverUpdate, ngbIntegration }) => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [activeWaiverIndex, setActiveWaiverIndex] = React.useState(null);

  const refetchForm = {
    refetchQueries: [{ query: GetForm.QUERY, variables: { formId: formId } }],
  };

  const [deleteWaiver] = useMutation(DeleteWaiver.MUTATION, refetchForm);

  const openWaiverDrawer = () => setDrawerOpen(true);

  const closeWaiverDrawer = () => {
    setDrawerOpen(false);
    setActiveWaiverIndex(null);
  };

  const isHockeyCanadaEnabledForm = ngbIntegration?.ngbIntegrationId === 3 && ngbIntegration?.enabled;
  const displayableWaivers = isHockeyCanadaEnabledForm ? waivers.filter(waiver => waiver.externalId === null) : waivers;

  return (
    <>
      {/* Checking for hockey Canada */}
      {isHockeyCanadaEnabledForm &&
        <NgbWaiverPill />
      }

      {/* Waivers that are saved in component state. */}
      {displayableWaivers &&
        displayableWaivers.map((waiver, index) => (
          <WaiverPillButton
            formId={formId}
            key={index}
            index={index}
            waiver={waiver}
            setActiveWaiverIndex={setActiveWaiverIndex}
            setDrawerOpen={setDrawerOpen}
            deleteWaiver={deleteWaiver}
            setWaivers={(index) => setWaivers(waivers.filter((_, i) => i !== index))}
            handleWaiverUpdate={handleWaiverUpdate}
          />
        ))}

      <FlexPillButton onClick={openWaiverDrawer}>
        <div className="u-size1of1 u-flex">
          <Button
            mods="u-flex u-flexJustifyStart u-flexAlignItemsStart"
            type="link"
            style={{ padding: 0, borderWidth: 0, marginTop: 2 }}
          >
            <Icon name="plus" style={{ width: 24, height: 24 }} />
          </Button>

          <p className="u-flex u-flexAlignSelfCenter">Add Digital Agreements</p>
        </div>
      </FlexPillButton>

      <NewWaiver
        formId={formId}
        waiver={activeWaiverIndex !== null ? displayableWaivers[activeWaiverIndex] : null}
        onSaveWaiver={handleWaiverSave}
        open={drawerOpen}
        closeFn={closeWaiverDrawer}
      />
    </>
  );
};

export default WaiverForm;
